/**
 * SSL template configuration
 * Matches: SSL.SSL
 */
import type { TemplateConfig, TemplateField } from '../types'
import { createExpandedRowRender } from '../../expanded-row'
import { defaultQuotaCalculator, defaultIsExpandable } from '../shared'

// ============================================================================
// Fields
// ============================================================================

export const SSL_FIELDS: TemplateField[] = [
    { key: 'ssl', names: ['ssl', 'certificate'], label: 'SSL' },
]

// ============================================================================
// Template Config
// ============================================================================

export const sslTemplate: TemplateConfig = {
    id: 'ssl',
    patterns: ['ssl.ssl', 'ssl'],
    priority: 10,
    fields: SSL_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
}

// Export all SSL templates
export const sslTemplates = [sslTemplate]
